import { Injectable } from '@angular/core';
import { CATBundle } from '../../../models/cat-bundle.model';

@Injectable({
  providedIn: 'root'
})
export class AndroidService {

  constructor() { }

  getCatBundle() {
    return new Promise<CATBundle>(resolve => {
        resolve(this.handleAndroidBridge());
    });
  }

  private handleAndroidBridge(): CATBundle | undefined {
    let tokenBundle: string;

    try {
      tokenBundle = window['android'].getTokens();
    } catch (error) {
      this.handleError('[Android Service] Error getting CATBundle')
      return undefined;
    }

    const CATBundleAndroid = JSON.parse(tokenBundle);

    const CATBundleExist = !!CATBundleAndroid && !!CATBundleAndroid.cat1_token;

    if (CATBundleExist) {
      return CATBundleAndroid;
    } else {
      this.handleError('[Android Service] CATBundle not found');
      return undefined;
    }
  }
  
  private handleError(message: string) {
    console.error(message);
  }
}

